<template>
  <div
    class="work-package-head-container"
    :style="`fill: ${foreground_color};`"
    @click="$emit('clickHeader')"
    >
    <div class="work-package-head-left-side">
      <TIcon
        :name="getNewIcon(head.icon)"
        large
      />
      <TText
        :text="head.token"
        :color="foreground_color"
        :size="32"
        :font_weight="400"
      />
      <div class="work-package-head-small-text-container">
        <TText
          class="work-package-head-small-text"
          :text="head.name"
          :color="foreground_color"
          small
        />
        <TText
          class="work-package-head-small-text"
          :text="head.area"
          :color="foreground_color"
          small
        />
      </div>
      <div
        v-if="is_step_card_header && step_card.offset"
        class="work-package-head-stepcard-offset"
        >
        {{step_card.offset}} TT
      </div>
    </div>
    <button
      v-if="!hide_status && !is_step_card_header"
      :disabled="readonly"
      class="work-package-head-status-btn"
      @click.prevent.stop="turnOnStatusDisplay()"
      >
      <StatusCircleStandard
        :filled_count="head.status_done_count"
        :is_stop="head.status_is_stop!=='none'"
        :color="foreground_color"
      >
        <template #content>
          <div class="work-package-head-icon-container">
            <TransitionRotate v-for="(state, index) in status" :key="`status-display${index}`">
              <!-- <v-icon
                v-if="state.is_stop
                  ? head.status_is_stop!=='none'
                  : head.status_done_count===state.status_index && head.status_is_stop==='none'"
                class="work-package-head-icon"
                :color="state.is_stop
                  ? stop_color
                  : foreground_color"
              >
                {{ getIcon(state) }}
              </v-icon> -->
              <TIcon
                v-if="state.is_stop
                  ? head.status_is_stop!=='none'
                  : head.status_done_count===state.status_index && head.status_is_stop==='none'"
                class="work-package-head-icon"
                :name="getIcon(state)"
                :color="state.is_stop
                  ? stop_color
                  : foreground_color"
              />
            </TransitionRotate>
          </div>
        </template>
      </StatusCircleStandard>
    </button>
    <!-- step card status -->
    <button
      v-else
      class="work-package-head-status-btn"
      @click.prevent.stop="$emit('toggleStepCardStatus')"
      >
      <StatusCircleStandard
        :filled_count="head.status_done_count"
        :is_stop="false"
        :color="foreground_color"
      >
      <template #content>
        <div class="work-package-head-icon-container-step-card" :style="`background-color: ${calc_hex_color(step_card.work_package_color)}`">
          <TIcon
            :name="$store.state.Ultra.step_icons[step_type]"
            color="black"
          />
        </div>
      </template>
    </StatusCircleStandard>
  </button>

    <TransitionAccordion>
      <!-- NOTE: v-click-outside - don't put brackets behind methode name -->
      <PopUpOverlay
        v-if="show_status_selection"
        :width="'340px; max-width: 100%'/* NOTE: this should have the same static width as the container */"
        :margin="8"
        :position_css="is_taktarea_details ? 'bottom: 0; right: 0;' : 'bottom: 0; right: 0; transform: translate(0px, calc(100% - 5px));'"
        :is_no_cancel="true"
        :key="show_comment_input"
        @closeOverlay="turnOffStatusDisplay"
        @click.native.prevent.stop="turnOnStatusDisplay()"
        z_index="11"
      >
        <template #body>
          <div class="work-package-head-status-selection-buttons">
            <ClickablePopUpIcon
              v-for="(state, index) in status"
              :key="`status-display${index}`"
              :icon="getIcon(state)"
              :icon_opacity="getStatusIconOpacity(state)"
              :description="state.tooltip"
              :color="state.is_stop
                ? stop_color
                : full_color"
              :is_underlined="
                head.status_done_count === state.status_index ||
                head.status_is_stop !== 'none' && state.is_stop"
              :disabled="state.tooltip !== 'Stop' && head.status_is_stop !== 'none'"
              @selected="clickStatus(state)"
            />
            <!-- @selected="state.tooltip.toLowerCase() !== 'stop'?(selectStatus(state), turnOffStatusDisplay()):($emit('openCommentInput'), show_comment_input = !show_comment_input)" -->
          </div>
          <div v-if="show_comment_input" style="margin: 8px">
            <TextArea
              style="width: 100%;"
              :label="`LogList Comment`"
              :max_char_count="127"
              :height="64"
              background_color="color-1"
              :value="comment"
              @change="comment = $event"
            />
            <div class="d-flex justify-space-around mt-4">
              <v-btn color="red" @click.prevent.stop="show_comment_input = false">Cancel</v-btn>
              <v-btn color="green" @click.prevent.stop="$emit('selectStopStatus', comment), show_comment_input = false, comment = ''">Done</v-btn>
            </div>
          </div>
        </template>
      </PopUpOverlay>
    </TransitionAccordion>
    <div
      v-if="is_step_card_header"
      class="work-package-head-stepcard-text"
      >
      {{step_card.text}}
    </div>
  </div>
</template>

<script>
import colors from 'vuetify/lib/util/colors';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import StatusCircleStandard from '@/components/WorkPackageWIP/StatusCircleStandard.component.vue';
import TransitionRotate from '@/components/WorkPackageWIP/TransitionRotate.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
import ClickablePopUpIcon from '@/components/WorkPackageWIP/ClickablePopUpIcon.component.vue';
import { mapGetters, /* mapActions, */ } from 'vuex';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      StatusCircleStandard,
      TIcon,
      TText,
      TransitionRotate,
      TransitionAccordion,
      TextArea,
      PopUpOverlay,
      ClickablePopUpIcon,
    },

    mixins: [
      TColor,
    ],

    props: [
      'head', // is object, has token, name, area, status_is_stop (string) - status_done_count (number)
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'location',
      'isMobile',
      'readonly',
      'is_step_card_header',
      'step_type',
      'hide_status',
      'step_card',
      'is_taktarea_details'
    ],

    computed: {
      ...mapGetters('WorkPackage', [
        'getNewIcon'
        ],
      ),

      full_color() {
        return this.getColor();
      },

      status() {
        return this.$store.state.Ultra.status_array.slice(1);
      },
    },

    data: () => ({
      stop_color: '#F44336', // stop_color MUST be a 7 digit hex-color for transparency to work
      show_status_selection: false,
      show_comment_input: false,
      comment: '',
    }),

    methods: {
      getIcon(state) {
        if(state.is_stop && this.head.status_is_stop === 'ai_stop') {
          return state.ai_icon;
        }
        return state.icon;
      },

      turnOnStatusDisplay() {
        if(!this.show_status_selection) {
          this.show_status_selection = true;
          this.$emit('toggle_status_popup', true);
        }
      },

      turnOffStatusDisplay() {
        if(this.show_status_selection) {
          this.show_status_selection = false;
          this.$emit('toggle_status_popup', false);
        }
      },

      selectStatus(state) {
        // TODO: WIP
        // if(state.is_stop === 'stop') {
        //   this.show_justification = !this.show_justification;
        //   return;
        // }
        // TODO: END WIP

        // emit what was clicked either way
        // gets handled in parent component (TODO: or shouldn't it?)
        this.$emit('selectStatus', state);

        // TODO: this isn't solved elegantly yet
        // if stop is set, don't close when a status other than stop is clicked
        // if(this.head.status_is_stop != 'none' && !state.is_stop) {
        //   return; // don't toggle the display of status selection
        // }
        this.turnOffStatusDisplay();
      },

      getStatusIconOpacity(state) {
        if(state.is_stop || this.head.status_is_stop === 'none') { // if the in use state is 'stop' or current head state is 'none'
          return 1; // full opacity
        }
        else { // either 'stop' or 'ai_stop' is set
          if(state.status_index === this.head.status_done_count) { // if this state is in use
            return .75; // somewhat opaque
          }
          else { // this state is currently not in use
            return .25; // set to 25% transparency
          }
        }
      },
      calc_hex_color(color) {
        if (color.includes('black')) {
          return '#000'
        } else if (color.includes('white')) {
          return '#FFF'
        } else {
          let color_parts = color.split(' ');
          if (color_parts.length === 1) {
            color_parts.push('lighten-1')
          }
          let color_part_first = color_parts[0].split("-");
          color_parts[0] = `${color_part_first[0]}${color_part_first.length > 1?color_part_first[1].substring(0,1).toUpperCase():''}${color_part_first.length > 1?color_part_first[1].substring(1):''}`

          color_parts[1] = color_parts[1].replace("-","");

          if (colors[color_parts[0]]) {
            // vuetify standard colors
            return colors[color_parts[0]][color_parts[1]];
          } else {
            // vuetify theme colors -> old values
            let theme_colors = this.$vuetify.theme.themes[this.$vuetify.theme.isDark?'dark':'light'];
            if (theme_colors[color]) {
              return theme_colors[color];
            } else {
              // default value yellow lighten-1
              return '#ffee58';
            }
          }
        }
      },
      clickStatus(state){
        if (state.tooltip.toLowerCase() !== 'stop') {
          this.selectStatus(state);
          this.turnOffStatusDisplay();
        } else {
          if(this.is_taktarea_details){
            this.$emit('clickStopStatus');
          } else {
            this.$emit('openCommentInput');
            this.show_comment_input = !this.show_comment_input;
          }
        }
      }
    },
  }
</script>

<style>
.work-package-head-container {
  position: relative;
  display: flex;
  height: 70px;
  justify-content: space-between;
}
.work-package-head-left-side {
  display: flex;
  height: 100%;
  max-width: calc(100% - 70px); /* NOTE: not optimal: work-package-head-status-btn has a width of 70px */
  grid-gap: 4px;
  align-items: center;
  padding-left: 8px;
}
.work-package-head-small-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}
.work-package-head-small-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.work-package-head-status-btn {
  width: 70px;
  height: 70px;
  flex-shrink: 0;
}
.work-package-head-icon-container {
  width: 24px;
  height: 24px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
}
.work-package-head-icon, .work-package-head-icon-container > .v-icon {
  position: absolute;
}
.work-package-head-icon-container-step-card {
  width: 40px;
  height: 40px;
  z-index: -1;
  border-radius: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
}
.work-package-head-status-selection {
  width: 100%;
  background-color: rgba(0,0,0,.93);
  position: absolute;
  border-radius: 8px;
  bottom: 0;
  transform: translateY(100%);
  z-index: 3;
  box-shadow: 0px 5px 5px rgba(0,0,0,.33);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.work-package-head-status-selection-buttons {
  display: flex;
  flex-wrap: wrap;
  height: auto;
  width: 100%;
  align-items: center;
  /* grid-gap: 8px; */
  /* padding: 16px; */
  /* padding: 8px; */
  padding: 1px 3px;
  justify-content: space-between;
}
.work-package-head-status-selection-buttons > button {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.work-package-head-status-selection-justification {
  height: auto;
  width: 100%;
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
  grid-gap: 16px;
  align-items: flex-end;
}
.work-package-head-status-selection-justification > .v-btn {
  letter-spacing: normal !important;
  text-indent: 0 !important;
  text-transform: none !important;
}
.work-package-head-status-selection-justification > .v-textarea {
  width: 100%;
}
.workpackage-head-step-card-checkbox {
  margin: 5px 5px 5px 0px;
}
.work-package-head-stepcard-offset {
  color: black;
  white-space: nowrap;
  margin-left: 5px;
}
.work-package-head-stepcard-text {
  position: absolute;
  width: calc(100% - 68px);
  bottom: 2px;
  left: 12px;
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}
</style>
